import React from 'react'
import {Switch} from 'antd'
import './index.css'

const RSwitch = (props) => {
  const {size, checked, changeValue, able = true} = props

  const handleChangeSize = val => {
    if (!able) return
    changeValue(val)
  }
  return (
    <Switch className={`r-switch ${size} ${able ? "" : "disabled"}`} checkedChildren="是" unCheckedChildren="否"
            checked={checked}
            onChange={(val) => handleChangeSize(val)}></Switch>
  )

}


export default RSwitch
